import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import NewLoginModal from '../NewLoginModal/script';

import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const domId = createUniqueId();
let componentProps = null;

const renderLoginBar = (props) => {
    const component = LoginBar({ ...componentProps, ...props });
    dom.$id(domId).outerHTML = component;
};

const LoginBar = (props = {}) => {
    componentProps = props;
    const { loadLogin, loginSuccessCb, notLoginBarDesc = '登录后可领取优惠券至指定账户' } = props;
    const data = { 
        domId,
        notLoginBarDesc
     };
    const events = {
        showLogin: () => {
            NewLoginModal({ loadLogin, loginSuccessCb });
        },
        changeLogin: () => {
            NewLoginModal({ loadLogin, loginSuccessCb });
        },
    };
    const component = createComponent(tpl, { data, style, props }, events);

    return component;
};

export default LoginBar;
export { renderLoginBar };
